import React from 'react'

import { Field } from 'redux-form'
import Autosuggest from 'features/Autosuggest'
import Radio from 'components/Input/Radio'
import CheckboxRow from 'components/Input/CheckboxRow'
import SelectPretty from 'components/Input/SelectPretty'
import Button from 'components/Button'
import { Link } from 'react-router'

import cn from 'classnames'
import sLay from 'styles/modules/layout.scss'
import sText from 'components/Text/Text.scss'
import sMarg from 'styles/modules/margins.scss'
import {
  vRequired,
  vAutosuggestIdentical,
  vAutoSuggestLength,
} from 'components/Input/Input.validations'

const vSmartNumberIdentical = vAutosuggestIdentical(
  'numberSelected',
  'You must select an number from the dropdown.'
)
const vSmartNumberLength = vAutoSuggestLength(
  'numberSelected',
  6,
  "Max search string is 6 chars. Don't include 1300 or 1800."
)

export default props => {
  const { prev, change, formData, availableNumbers, numberType } = props
  const onSuggestionSelected = (event, { suggestion }) => {
    change('number', suggestion.value)
    change('numberWithLetters', suggestion.meta.numberWithLetters)
    change('premiumNumberMonthlyFee', suggestion.meta.premiumNumberMonthlyFee)
    change('numberSelected', suggestion.value)
  }
  const clearNumber = () => {
    change('number', '')
    change('numberWithLetters', '')
    change('premiumNumberMonthlyFee', '')
    change('numberSelected', '')
  }
  return (
    <div>
      <div className={cn(sText.descrip3, sMarg.mb30)}>
        Nothing beats a fresh start. We can provide both Standard and Premium Virtual Numbers.
        Premium Numbers are numbers like 1300 888 888 or 1300 ABC or words used to replace numbers
        when dialling on the keypad. Think 1300 Flowers for a Florist. Please Note: We cannot
        guarantee premium numbers or keywords until your order has been completed.
      </div>
      <Field
        label={`I just want a standard ${numberType} number.`}
        component={Radio}
        afterChange={clearNumber}
        name="isPremiumNumber"
        radioValue={false}
        style={{ marginBottom: '15px' }}
      />
      <Field
        label={`I want a premium ${numberType} number.`}
        component={Radio}
        afterChange={clearNumber}
        name="isPremiumNumber"
        radioValue
      />
      <br />
      <br />
      {formData.isPremiumNumber ? (
        <Field
          label="Premium Search (numbers or words)"
          component={Autosuggest}
          autosuggestType="smartnumber"
          numberType={numberType}
          onSuggestionSelected={onSuggestionSelected}
          name="number"
          info={`Don't include ${numberType} in your search. Both letters and numbers work.`}
          validate={[vRequired, vSmartNumberLength, vSmartNumberIdentical]}
        />
      ) : (
        <Field
          label="Search Standard Numbers"
          component={SelectPretty}
          options={availableNumbers.map(number => ({
            value: number,
            name: number,
          }))}
          name="number"
          validate={[vRequired]}
        />
      )}
      {formData.number && formData.isPremiumNumber && formData.premiumNumberMonthlyFee && (
        <Field
          name="confirmFees"
          component={CheckboxRow}
          style={{ margin: '30px 0' }}
          validate={[vRequired]}
        >
          I understand that this premium number is associated with a monthly payment of $
          {formData.premiumNumberMonthlyFee} and a 12 month contract. A prepayment of $45 will be
          charged to your nominated credit card on submission of this order. Minimum cost of $
          {formData.premiumNumberMonthlyFee * 12}.{' '}
          <Link target="_blank" to="/phonewords-terms">
            Learn more.
          </Link>
        </Field>
      )}
      <div
        className={cn(sLay['layout-column'], sLay['layout-align-center-center'])}
        style={{ marginTop: '40px' }}
      >
        <Button color="tertiary" type="submit" disabled={!formData.number}>
          Next
        </Button>
        <br />
        <br />
        <Button plain onClick={prev}>
          Back
        </Button>
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Numbers/NumbersSelectNewNumberStep/NumbersSelectNewNumberStep.jsx